import { getApiUrl, AXIOS_UNAUTHED } from './shared';

const getLogo = (languageCode) => {
  return AXIOS_UNAUTHED.get(`${getApiUrl()}/public/images/logo?region=${languageCode}`);
};

export { getLogo };
